import {Sede} from "../../Admin/models/Sede";
import {VoceProgetto} from "./VoceProgetto";
import {Azienda} from "../../Admin/models/Azienda";

export class Destinazione extends Sede {
  progetto?: number;
  sede?: number;
  pagato?:boolean;
  spedire?: boolean;
  spedito?: boolean;
  voci?: VoceProgetto[]
  id_edizione?: number;
  id_sede?: number;
  modifica?: boolean;
  nominativo?: string;
  clienteObject?: Azienda;
  ordine?: string;
  francoDeposito?: boolean;
  dataSpedito?: string;
  codAdhoc?: any;

  constructor() {
    super();
    this.pagato = false;
    this.spedire = false;
    this.spedito = false;
    this.francoDeposito = false;
    this.voci = [];
  }
}
